import React from "react";
import { Link } from "react-router-dom";
import { Flex, Image, IconButton} from "@chakra-ui/react";
import logo from "../../assets/images/logo1.png";
import openIcon from "../../assets/icons/sidebar-open.svg";
import closeIcon from "../../assets/icons/sidebar-close.svg";

function SidebarHeader({ isSidebarOpen, toggleSidebar }) {
  return (
    <Flex
      justifyContent={isSidebarOpen ? "space-between" : "center"}
      alignItems="center"
      p="4"
      borderBottom="1px"
      borderColor="blackAlpha.200"
      h="8vh"
    >
      {isSidebarOpen && (
        <Link to="/home">
          <Image src={logo} height="23px" />
        </Link>
      )}
      <IconButton
        icon={
          <Image src={isSidebarOpen ? closeIcon : openIcon} height="24px" />
        }
        onClick={toggleSidebar}
        bg="white"
        aria-label="Toggle Sidebar"
        size="sm"
        _hover={{ bg: "transparent" }}
      />
    </Flex>
  );
}

export default SidebarHeader;
